import { Icon, IconProps } from "./Icon";

export function IconCity(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M.11 23h24v1h-24zM15 22v-5.7a1.3 1.3 0 0 0-1.3-1.3h-3.41A1.3 1.3 0 0 0 9 16.3V22h1v-5.7a.3.3 0 0 1 .3-.3h3.4a.29.29 0 0 1 .3.3V22ZM2 1.29a.29.29 0 0 1 .13-.24A.28.28 0 0 1 2.4 1l6.44 3.26a.27.27 0 0 1 .16.25V6H6.28A1.28 1.28 0 0 0 5 7.28V22h1V7.28A.28.28 0 0 1 6.28 7h11.44a.28.28 0 0 1 .28.28V22h1V10h2.68a.33.33 0 0 1 .32.33V22h1V10.33A1.33 1.33 0 0 0 21.68 9H19V7.28A1.28 1.28 0 0 0 17.72 6H10V4.51a1.27 1.27 0 0 0-.71-1.15L2.84.13a1.26 1.26 0 0 0-1.23.08A1.28 1.28 0 0 0 1 1.29V22h1Z" />
    </Icon>
  );
}
